const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

const DATE_TIME_WITH_SECONDS_OPTIONS: Intl.DateTimeFormatOptions = {
  ...DATE_TIME_OPTIONS,
  second: "2-digit",
};

const SHORT_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "numeric",
};

const COMPACT_DATE_TIME_WITH_SECONDS_OPTIONS: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
};

export const formatDateTime = (iso: string): string =>
  new Date(iso).toLocaleString(undefined, DATE_TIME_OPTIONS);

export const formatNullableDateTime = (value: string | null): string =>
  value ? formatDateTime(value) : "—";

export const formatNullableDateTimeWithSeconds = (value: string | null): string =>
  value ? new Date(value).toLocaleString(undefined, DATE_TIME_WITH_SECONDS_OPTIONS) : "—";

export const formatNullableCompactDateTimeWithSeconds = (value: string | null): string =>
  value ? new Date(value).toLocaleString(undefined, COMPACT_DATE_TIME_WITH_SECONDS_OPTIONS) : "-";

export const formatShortDate = (iso: string): string =>
  new Date(iso).toLocaleDateString(undefined, SHORT_DATE_OPTIONS);
